import { KeyValue } from "@angular/common";

export class IdentityUser
{
    id: string;
    username: string;
    firstName: string;
    lastName: string;
    email: string;
    pushNotifications: boolean;
    inAppNotifications: boolean;
    sysAdmin: boolean;
    language: string;

	policies: string[];

	customer: KeyValue<number, string>;
}

export const enum AuthenticationMode
{
    pCode = 1,
    AzureAD = 2
}

export const enum Claim
{
    // .net core identity claims
    NameIdentifier = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier',
    Name = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name',
    GivenName = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname',
    Surname = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname',
    EmailAddress = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress',

    // custom claims
    Policies = 'customclaims/policies',
    SysAdmin = 'customclaims/sysadmin',
	Language = 'customclaims/language',
	CustomerId = 'customclaims/customerId',
	Customer = 'customclaims/customer'
}

export enum Policies
{
	//----------------------------------------------------------
	// purges
	//----------------------------------------------------------

	// interventions
	InterventionsRead,
}